<template>
  <v-expansion-panels>
    <v-expansion-panel
      v-for="conduct in ductConfigurationData"
      :key="conduct.uuid"
    >
      <v-expansion-panel-header>
        <micro-duct-panel-header
          :conduct-data="conduct"
          :micro-ducts-list="microDuctsList"
        />
      </v-expansion-panel-header>
      <v-expansion-panel-content id="content-panel">
        <micro-duct-panel-content
          :duct-configuration-data="
            conduct.microducts_bundles ?
            conduct.microducts_bundles[0] :
            conduct
          "
          :cables-list="cablesList"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapActions } from 'vuex';
import MicroDuctPanelHeader from './MicroDuctPanelHeader.vue';
import MicroDuctPanelContent from './MicroDuctPanelContent.vue';

export default {
  name: "CablesMicroDucts",

  components: {
    MicroDuctPanelHeader,
    MicroDuctPanelContent
  },

  props: {
    pathwayUuid: {
      type: String,
    },

    actionType: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      ductConfigurationData: null,
      microDuctsList: [],
      cablesList: []
    }
  },

  mounted() {
    if (this.actionType !== 'create') {
      this.getPathwayDuctConfig();
    }
    this.loadMicroDuctMaterials();
    this.loadCableMaterials();
  },

  methods: {
    ...mapActions(["getPathwayDuctConfiguration", "fetchStockMaterialsList"]),

    async getPathwayDuctConfig() {
      try {
        this.ductConfigurationData = await this.getPathwayDuctConfiguration(this.pathwayUuid);
      } catch (e) {
        console.error(e);
      }
    },

    async loadMicroDuctMaterials() {
      try {
        this.microDuctsList = await this.fetchStockMaterialsList({
          material_family_id: 'ud',
          append: "family_specific_fields"
        });
      } catch (e) {
        console.log(e);
      }
    },

    async loadCableMaterials() {
      try {
        this.cablesList = await this.fetchStockMaterialsList({
          material_family_id: 'ca'
        });
      } catch (e) {
        console.log(e);
      }
    },
  }
}

</script>

<style scoped>
.v-expansion-panel-header.v-expansion-panel-header--active {
  border-bottom-style: solid;
  border-bottom-color: #e3e3e3;
}

#content-panel>>>div.v-expansion-panel-content__wrap {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Pathways/CablesMicroDucts.vue